import { LegacyDateTimeFormatStringComponent } from './types';

export const LOCALIZED_DATE_TIME_FEATURE_FLAG = 'LocalizedDateTime';

export const FORMAT_COMPONENTS_WITH_TIME = [
  LegacyDateTimeFormatStringComponent.LocalizedFullDateWithTime,
  LegacyDateTimeFormatStringComponent.LocalizedTime,
  LegacyDateTimeFormatStringComponent.MilitaryHourWithAnyDigits,
  LegacyDateTimeFormatStringComponent.MeridiemHourWithAnyDigits,
  LegacyDateTimeFormatStringComponent.HourOfDayWithAnyDigits,
  LegacyDateTimeFormatStringComponent.MeridiemWithLowercase,
  LegacyDateTimeFormatStringComponent.MeridiemWithUppercase,
  LegacyDateTimeFormatStringComponent.MinutesWithAnyDigits,
  LegacyDateTimeFormatStringComponent.SecondsWithAnyDigits,
  LegacyDateTimeFormatStringComponent.FractionalSecondsWithOneDecimal,
  LegacyDateTimeFormatStringComponent.OffsetWithColon,
];

export const FORMAT_COMPONENTS_WITH_MILITARY_TIME = [
  LegacyDateTimeFormatStringComponent.MilitaryHourWithAnyDigits,
];

export const FORMAT_COMPONENTS_WITH_TWELVE_HOUR_TIME = [
  LegacyDateTimeFormatStringComponent.MeridiemHourWithAnyDigits,
  LegacyDateTimeFormatStringComponent.HourOfDayWithAnyDigits,
  LegacyDateTimeFormatStringComponent.MeridiemWithLowercase,
  LegacyDateTimeFormatStringComponent.MeridiemWithUppercase,
  LegacyDateTimeFormatStringComponent.MinutesWithAnyDigits,
  LegacyDateTimeFormatStringComponent.SecondsWithAnyDigits,
  LegacyDateTimeFormatStringComponent.FractionalSecondsWithOneDecimal,
];

export const FORMAT_COMPONENTS_WITH_TIMEZONE_OFFSET = [
  LegacyDateTimeFormatStringComponent.OffsetWithColon,
];

export const FORMAT_COMPONENTS_WITH_FULL_DATE = [
  LegacyDateTimeFormatStringComponent.LocalizedDayName,
  LegacyDateTimeFormatStringComponent.LocalizedFullDateWithTimeAndDay,
];

export const FORMAT_COMPONENTS_WITH_SHORT_DATE = [
  LegacyDateTimeFormatStringComponent.MonthNameAbbreviation,
];

export const FORMAT_COMPONENTS_WITH_NUMERIC_DATE = [
  LegacyDateTimeFormatStringComponent.MonthNumberWithAnyDigits,
  LegacyDateTimeFormatStringComponent.MonthNumberWithTwoDigits,
  LegacyDateTimeFormatStringComponent.LocalizedNumericDate,
];
